module.exports = "<div class=\"row\">\r\n  <div class=\"col-12\">\r\n    <small><b>Trip Load Time</b></small>\r\n    <br>\r\n    <small>Configure the amount of time in <b>minutes</b> allocated for passengers to board the vehicles </small>\r\n    <br>\r\n    <input class=\"form-conntrol setting-input\" [(ngModel)]=\"runConfig.loadTime\" type=\"number\">\r\n    <hr>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin-dashboard/optimizer/advanced-settings-dialog/advanced-settings-dialog.component.html
// module id = ./src/app/admin-dashboard/optimizer/advanced-settings-dialog/advanced-settings-dialog.component.html
// module chunks = main